import * as React from 'react'
import { useState, useEffect } from 'react'
import './Befores.scss'

const Befores = ({ type = 'get' }) => {
  return <span className={'befores-tag' + ' ' + type}>{type}</span>
}

export default Befores
